import { TabItem } from "@components-common/layouts";
import { map } from "ramda";
//import { CourseScreen } from "./screens";
const createPath = (path: string) => `/courses/:courseId/${path}`;

const mapTab = (tab: Omit<TabItem,"index">) => ({...tab,path:createPath(tab.path)});
//type CourseTabItem = TabItem & {routeId: CourseScreen}

export const courseTabs = map(mapTab,[
  {
    label: "Summary",
    path: "summary",
 //   index: 0,
    component: <></>,
    routeId: "courses_edit_tabbed"
  },
  {
    label: "Students",
    path: "students",
 //   index: 1,
    component: <></>,
    routeId: "courses_students_index"
  },
  {
    label: "Lecturers",
    path: "lecturers",
  // index: 2,
    component: <></>,
    routeId: "courses_lecturers_index"
  },
  {
    label: "Groups",
    path: "groups",
  // index: 3,
    component: <></>,
    routeId: "courses_groups_index"
  },
  {
    label: "Resources",
    path: "resources",
  // index: ,
    component: <></>,
    routeId: "courses_resources_index"
  },
  {
    label: "Assignments",
    path: "assignments",
  // index: 5,
    component: <></>,
    routeId: "courses_assignments_index"
  },
]) as any;
